import React from 'react';
import { Typography, Container, Grid, Divider } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { CardBase } from '@components/organisms';
import { isMobile } from "react-device-detect";
import moment from "moment";

const useStyles = makeStyles(theme => ({
    container: {
        marginTop: theme.spacing(2),
        display: 'flex',
    },
    itemContainer: {
        display: 'flex',
        paddingBottom: theme.spacing(1),
    },
    card: {
        backgroundColor: theme.palette.background.default,
        marginBottom: theme.spacing(1),
    },
    boldText: {
        fontWeight: 'bold',
    },
    paddingTop: {
        paddingTop: theme.spacing(2),
    },
}));

const SelectedEmployee = ({ employeeData }) => {
    const classes = useStyles();

    return (
        <Grid item xs={12} spacing={4} className={classes.container}>
            <CardBase className={classes.card}>
                {/* <Container>
                    <Grid item sm={12}>
                        <Typography variant="subtitle2" className={classes.boldText}>
                            Selected Employee:
                        </Typography>
                    </Grid>
                </Container> */}
                        <>
        {!isMobile ?
            <Grid container className={classes.itemContainer}>
                <Grid item sm={12}>
                    <Typography variant="h6">
                        {employeeData.firstName} {employeeData.lastName} ({employeeData.employeeID})
                    </Typography>
                    <Divider />
                </Grid>
                <Grid container className={classes.paddingTop}>
                    <Grid item sm={4}>
                        <Typography variant="subtitle2">
                            <b>Work Status:</b> {employeeData.userStatus}
                        </Typography>
                    </Grid>
                    <Grid item sm={4}>
                        <Typography variant="subtitle2">
                            <b>Email:</b> {employeeData.workEmail}
                        </Typography>
                    </Grid>
                    <Grid item sm={4}>
                        <Typography variant="subtitle2">
                            <b>Last Log In:</b> {moment(employeeData.lastLogin).format("MM-DD-YYYY h:mm A")}
                        </Typography>
                    </Grid>
                    <Grid container className={classes.paddingTop}>
                        <Grid item sm={1}>
                            <Typography variant="h6">
                                #
                            </Typography>
                        </Grid>
                        <Grid item sm={3}>
                            <Typography variant="h6">
                                Job Description
                            </Typography>
                        </Grid>
                        <Grid item sm={2}>
                            <Typography variant="h6">
                                BU #
                            </Typography>
                        </Grid>
                        <Grid item sm={2}>
                            <Typography variant="h6">
                                BU Name
                            </Typography>
                        </Grid>
                        <Grid item sm={2}>
                            <Typography variant="h6">
                                Region
                            </Typography>
                        </Grid>
                        <Grid item sm={2}>
                            <Typography variant="h6">
                                Division
                            </Typography>
                        </Grid>
                        <Grid item sm={12}>
                            <Divider />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container className={classes.paddingTop}>
                    <Grid item sm={1}>
                        <Typography variant="subtitle2">
                            1
                        </Typography>
                    </Grid>
                    <Grid item sm={3}>
                        <Typography variant="subtitle2">
                            {employeeData.jobTitleName}
                        </Typography>
                    </Grid>
                    <Grid item sm={2}>
                        <Typography variant="subtitle2">
                            {employeeData.businessUnitID}
                        </Typography>
                    </Grid>
                    <Grid item sm={2}>
                        <Typography variant="subtitle2">
                            {employeeData.businessUnitName}
                        </Typography>
                    </Grid>
                    <Grid item sm={2}>
                        <Typography variant="subtitle2">
                            {employeeData.regionName}
                        </Typography>
                    </Grid>
                    <Grid item sm={2}>
                        <Typography variant="subtitle2">
                            {employeeData.divisionName}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            :
            <>
                <Container className={classes.itemContainer}>
                    <Grid item xs={6}>
                        <Typography variant="subtitle2">
                            {employeeData.employeeID}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="subtitle2">
                            {employeeData.firstName} {employeeData.lastName}
                        </Typography>
                    </Grid>
                </Container>
                <Container className={classes.itemContainer}>
                    <Grid item xs={8}>
                        <Typography variant="subtitle2">
                            {employeeData.jobTitleName}
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <Typography variant="subtitle2">
                            {employeeData.businessUnitID}
                        </Typography>
                    </Grid>
                </Container>
            </>
        }
        </>
            </CardBase>
        </Grid>
    )
}

export default SelectedEmployee;
